import React from "react";
import { useNavigate } from "react-router";
import * as Common from "../../commons/common";
import styles from "./Error.module.css";

import Button from "antd/es/button/button";
import Result from "antd/es/result/index";

function PageError404() {
    const navigate = useNavigate();
    return (
        <div className={styles.pageWrapper}>
            <Result
                className={styles.result}
                status="404"
                title={<h2 className="fc-point">404</h2>}
                subTitle={
                    <span className="fw-rg fs-md fc-font1">
                        페이지를 찾을 수 없습니다.
                        <br />
                        입력하신 페이지의 주소와 경로가 정확한지 다시 한 번 확인 후 이용하시기 바랍니다
                    </span>
                }
                extra={
                    <Button className="btn-primary" onClick={() => navigate(Common.PAGE_DASHBOARD)}>
                        홈으로 이동
                    </Button>
                }
            />
        </div>
    );
}

export default PageError404;
